import api from '@/services/api'

export default {
  namespaced: true,
  state: {
    companyData: null,
    stats: {
      activeUsers: 0,
      totalUsers: 0,
      todayVisits: 0,
      accountStatus: 'ACTIVA',
    },
    loading: false,
  },
  getters: {
    companyInfo: (state, getters, rootState) => {
      // Priorizar datos del store principal
      return state.companyData || rootState.empresa
    },
    companyStats: (state) => state.stats,
    isLoading: (state) => state.loading,
  },
  mutations: {
    
    SET_STATS(state, stats) {
      state.stats = { ...state.stats, ...stats }
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
  },
  actions: {
    async fetchCompanyData({ commit, rootState }) {
      commit('SET_LOADING', true)
      try {
        // Si ya tenemos empresa en el store principal, usar esos datos
        if (rootState.empresa) {
          commit('SET_EMPRESA', rootState.empresa, { root: true })
        }

        // Intentar obtener stats del backend
        try {
          const response = await api.get('/empresa')
          if (response.data.company) {
            commit('SET_EMPRESA', response.data.company, { root: true })
          }
          if (response.data.stats) {
            commit('SET_STATS', response.data.stats)
          }
        } catch (error) {
          // Si falla, usar datos básicos
          console.warn('No se pudieron cargar stats del servidor:', error)
          // Establecer stats por defecto
          commit('SET_STATS', {
            activeUsers: 0,
            totalUsers: 0,
            todayVisits: 0,
            accountStatus: rootState.empresa?.estatus || 'ACTIVA',
          })
        }

        return { company: rootState.empresa }
      } catch (error) {
        console.error('Error al cargar datos de empresa:', error)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },
    async updateCompanyData({ commit }, data) {
      commit('SET_LOADING', true)
      try {
        const response = await api.put('/empresa/info-ppal', data)
        if (response.data.empresa) {
          commit('SET_EMPRESA', response.data.empresa, { root: true })
        }
        return response.data
      } catch (error) {
        console.error('Error al actualizar datos de empresa:', error)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },
  },
}